<div
    *ngIf="!performanceReport"
    class="agpr-wirePerformanceReport-placeholder"
>
    <div class="agpr-wirePerformanceReport-placeholder-mainContainer">
        <div class="lineChart">
            <span class="agpr-i-line-metrics" aria-hidden="true"></span>
        </div>
        <div class="mainText">{{ 'Amplify.wireReport.noReport' | localize}}</div>
        <div>{{ 'Amplify.wireReport.noReport.details' | localize }}</div>
    </div>
</div>
<div
    *ngIf="performanceReport"
    class="agpr-wirePerformanceReport"
    [agprLoading]="reportLoading"
>
    <div class="agpr-wirePerformanceReport-generalStats">
        <div class="agpr-wirePerformanceReport-generalStats-block">
            <div class="agpr-wirePerformanceReport-generalStats-label">{{ 'Amplify.wireReport.general.totalTraffic' | localize }}</div>
            <span class="agpr-wirePerformanceReport-generalStats-number">{{ performanceReport?.totalTraffic | significantDigits: 1 }}</span>
        </div>

        <div class="agpr-wirePerformanceReport-generalStats-block">
            <div class="agpr-wirePerformanceReport-generalStats-label">{{ 'Amplify.wireReport.general.totalPotentialVisibility' | localize }}</div>
            <span class="agpr-wirePerformanceReport-generalStats-number">{{ performanceReport?.totalPotentialVisibility | significantDigits: 1 }}</span>
        </div>

        <div class="agpr-wirePerformanceReport-generalStats-block">
            <div class="agpr-wirePerformanceReport-generalStats-label">{{ 'Amplify.wireReport.general.totalNumberOfPostings' | localize }}</div>
            <span class="agpr-wirePerformanceReport-generalStats-number">{{ performanceReport?.totalNumberOfPostings | significantDigits: 1 }}</span>
        </div>

        <div class="agpr-wirePerformanceReport-generalStats-block">
            <div class="agpr-wirePerformanceReport-generalStats-label">{{ 'Amplify.wireReport.general.totalLinkClicks' | localize }}</div>
            <span class="agpr-wirePerformanceReport-generalStats-number">{{ performanceReport?.totalLinkClicks | significantDigits: 1 }}</span>
        </div>

        <div class="agpr-wirePerformanceReport-generalStats-block">
            <div class="agpr-wirePerformanceReport-generalStats-label">{{ 'Amplify.wireReport.general.totalViews' | localize }}</div>
            <span class="agpr-wirePerformanceReport-generalStats-number">{{ performanceReport?.totalViews | significantDigits: 1 }}</span>
        </div>
    </div>

    <div class="agpr-wirePerformanceReport-clickStats">
        <div
            *ngIf="performanceReport?.topTargetClicks.length > 0"
            class="agpr-wirePerformanceReport-clickStats-block"
            role="list"
        >
            <div class="agpr-wirePerformanceReport-clickStats-header">
                <span>{{ 'Amplify.wireReport.click.topLinkClicks' | localize }}</span>
                <span class="agpr-wirePerformanceReport-clickStats-headerRateLabel">{{ 'Amplify.wireReport.click.clickRates' | localize }}</span>
            </div>

            <div
                *ngFor="let clickStat of performanceReport?.topTargetClicks"
                class="agpr-wirePerformanceReport-clickStats-row"
                role="listitem"
            >
                <a
                    [href]="clickStat?.url"
                    target="_blank"
                    class="agpr-wirePerformanceReport-clickStats-rowUrl"
                >
                    {{ clickStat?.urlDisplayString }}
                </a>
                <span class="agpr-wirePerformanceReport-clickStats-rowRate">{{ clickStat?.clickRate | percent:'1.1-1' }}</span>
            </div>
        </div>

        <div
            *ngIf="performanceReport?.topSourceClicks.length > 0"
            class="agpr-wirePerformanceReport-clickStats-block"
            role="list"
        >
            <div class="agpr-wirePerformanceReport-clickStats-header">
                <span>{{ 'Amplify.wireReport.click.topClicksBySource' | localize }}</span>
                <span class="agpr-wirePerformanceReport-clickStats-headerRateLabel">{{ 'Amplify.wireReport.click.clickRates' | localize }}</span>
            </div>

            <div
                *ngFor="let clickStat of performanceReport?.topSourceClicks"
                class="agpr-wirePerformanceReport-clickStats-row"
                role="listitem"
            >
                <a
                    [href]="clickStat?.url"
                    target="_blank"
                    class="agpr-wirePerformanceReport-clickStats-rowUrl"
                >
                    {{ clickStat?.urlDisplayString }}
                </a>
                <span class="agpr-wirePerformanceReport-clickStats-rowRate">{{ clickStat?.clickRate | percent:'1.1-1' }}</span>
            </div>
        </div>
    </div>

    <div class="agpr-wirePerformanceReport-postingStats-header">
        <span class="agpr-wirePerformanceReport-postingStats-headerLabel">{{ 'Amplify.wireReport.postings.header' | localize }}</span>
        <span class="agpr-wirePerformanceReport-postingStats-headerCount">{{ performanceReport?.totalNumberOfPostings }}</span>
    </div>

    <agpr-scroll-panel class="agpr-wirePerformanceReport-postingStats-scrollPanel">
        <div class="agpr-wirePerformanceReport-postingStatsWrapper">
            <table
                *ngIf="!!performanceReport"
                class="agpr-wirePerformanceReport-postingStats"
            >
                <thead class="agpr-wirePerformanceReport-postingStats-tableHeader">
                    <tr>
                        <th class="agpr-wirePerformanceReport-postingStats-screenshotHeader">{{ 'Amplify.wireReport.postings.screenshot' | localize }}</th>
                        <th class="agpr-wirePerformanceReport-postingStats-dateHeader">
                            <agpr-button
                                [style]="buttonTypes.link"
                                (click)="toggleSortPostingStats(postingSortType.date)"
                            >
                                {{ 'Amplify.wireReport.postings.date' | localize }}
                                <span
                                    role="img"
                                    class="agpr-wirePerformanceReport-postingStats-tableHeader-sortOrderIcon"
                                    [ngClass]="dateSortOrder === sortOrder.ascending ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                                    [attr.aria-label]="dateSortOrder === sortOrder.ascending ? 'ascending' : 'descending'"
                                ></span>
                            </agpr-button>
                        </th>
                        <th class="agpr-wirePerformanceReport-postingStats-urlHeader">{{ 'Amplify.wireReport.postings.url' | localize }}</th>
                        <th class="agpr-wirePerformanceReport-postingStats-alexaTrafficGlobalHeader">
                            <agpr-button
                                [style]="buttonTypes.link"
                                (click)="toggleSortPostingStats(postingSortType.alexaTraffic)"
                            >
                                <span>{{ 'Amplify.wireReport.postings.alexaTrafficGlobal.line1' | localize }}</span>
                                <span
                                    role="img"
                                    class="agpr-wirePerformanceReport-postingStats-tableHeader-sortOrderIcon"
                                    [ngClass]="alexaTrafficSortOrder === sortOrder.ascending ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                                    [attr.aria-label]="alexaTrafficSortOrder === sortOrder.ascending ? 'ascending' : 'descending'"
                                ></span>
                                <span>{{ 'Amplify.wireReport.postings.alexaTrafficGlobal.line2' | localize }}</span>
                            </agpr-button>
                        </th>
                        <th class="agpr-wirePerformanceReport-postingStats-mozDAHeader">
                            <agpr-button
                                [style]="buttonTypes.link"
                                (click)="toggleSortPostingStats(postingSortType.mozDA)"
                            >
                                {{ 'Amplify.wireReport.postings.mozDA' | localize }}
                                <span
                                    role="img"
                                    class="fa-regular fa-circle-info"
                                    agprTooltip="Amplify.wireReport.postings.mozDA.tooltip"
                                ></span>
                                <span
                                    role="img"
                                    class="agpr-wirePerformanceReport-postingStats-tableHeader-sortOrderIcon"
                                    [ngClass]="mozDASortOrder === sortOrder.ascending ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                                    [attr.aria-label]="mozDASortOrder === sortOrder.ascending ? 'ascending' : 'descending'"
                                ></span>
                            </agpr-button>
                        </th>
                        <th class="agpr-wirePerformanceReport-postingStats-otherHeader">
                            <agpr-button
                                [style]="buttonTypes.link"
                                (click)="toggleSortPostingStats(postingSortType.postingTraffic)"
                            >
                                <span class="agpr-wirePerformanceReport-postingStats-other--postingTraffic">{{ 'Amplify.wireReport.postings.postingTraffic' | localize }}</span>
                                <span
                                    role="img"
                                    class="agpr-wirePerformanceReport-postingStats-tableHeader-sortOrderIcon"
                                    [ngClass]="postingTrafficSortOrder === sortOrder.ascending ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                                    [attr.aria-label]="postingTrafficSortOrder === sortOrder.ascending ? 'ascending' : 'descending'"
                                ></span>
                                <span>{{ 'Amplify.wireReport.postings.potentialVisibility' | localize }}</span>
                            </agpr-button>
                        </th>
                    </tr>
                </thead>

                <tbody class="agpr-wirePerformanceReport-postingStats-tableBody">
                    <tr *ngFor="let posting of performanceReport.postingStats">
                        <td class="agpr-wirePerformanceReport-postingStats-screenshot">
                            <div
                                *ngIf="!!posting.thumbUrl"
                                class="agpr-wirePerformanceReport-postingStats-screenshotWrapper"
                            >
                                <img
                                    [src]="posting.thumbUrl"
                                    [alt]="'Amplify.wireReport.postings.screenshot' | localize"
                                    aria-hidden="true"
                                >
                            </div>
                            <div
                                *ngIf="!posting.thumbUrl"
                                class="agpr-wirePerformanceReport-postingStats-screenshotWrapper--noimg"
                            ></div>
                        </td>
                        <td class="agpr-wirePerformanceReport-postingStats-date">
                            <span
                                class="agpr-wirePerformanceReport-postingStats-dateCaptured"
                                [pTooltip]="posting.siteName"
                            >
                                {{ posting.siteNameDisplayString }}
                            </span>
                            <span>{{ posting.nqFirstSeenDateString }}</span>
                        </td>
                        <td class="agpr-wirePerformanceReport-postingStats-urls">
                            <a
                                [href]="posting.siteUrl"
                                target="_blank"
                                class="agpr-wirePerformanceReport-postingStats-urls--site"
                            >
                                {{ posting.siteUrlDisplayString }}
                            </a>
                            <a
                                [href]="posting.releaseUrl"
                                target="_blank"
                                class="agpr-wirePerformanceReport-postingStats-urls--release"
                            >
                                {{ posting.releaseUrlDisplayString }}
                            </a>
                        </td>
                        <td class="agpr-wirePerformanceReport-postingStats-alexaTrafficGlobal">
                            <span class="agpr-wirePerformanceReport-postingStats-alexaTrafficGlobal--rank">{{ posting.alexaGlobalRank | number }}</span>
                            <span [ngClass]="posting.alexaGlobalChange >= 0 ? 'agpr-wirePerformanceReport-postingStats-alexaTrafficGlobal--increase' : 'agpr-wirePerformanceReport-postingStats-alexaTrafficGlobal--decrease'">
                                <span *ngIf="posting.alexaGlobalChange >= 0">+</span>{{ posting.alexaGlobalChange }}
                            </span>
                        </td>
                        <td class="agpr-wirePerformanceReport-postingStats-mozDA">{{ posting.mozDaScore }}</td>
                        <td class="agpr-wirePerformanceReport-postingStats-other">
                            <span class="agpr-wirePerformanceReport-postingStats-postingTraffic">{{ posting.totalTraffic | number }}</span>
                            <span class="agpr-wirePerformanceReport-postingStats-potentialVisibility">{{ posting.potentialVisibility | number }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </agpr-scroll-panel>
</div>
